import { saveStateToStorage } from '../../../actions';
import { toggleCampaignPickerPinned as toggleCampaignPickerPinnedAction } from '../actions';

const toggleCampaignPickerPinned = isPinned => dispatch => {
    dispatch(toggleCampaignPickerPinnedAction(isPinned));
    dispatch(saveStateToStorage());
};

export default toggleCampaignPickerPinned;
